import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import { DefaultListFeilds as df, AuditState as aud, PayState as ps, TableAction as tac } from '../../../types';
import { TableActionType as ta } from '@/util/enum';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '手机号',
            dataIndex: df.tel,
            key: df.tel,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '姓名',
            dataIndex: df.name,
            key: df.name,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '付款金额（元）',
            dataIndex: df.payMoney,
            key: df.payMoney,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '账户',
            dataIndex: df.account,
            key: df.account,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: df.stateDesc,
            key: df.stateDesc,
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '付款状态',
            dataIndex: df.payStateDesc,
            key: df.payStateDesc,
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '付款说明',
            dataIndex: df.payRemark,
            key: df.payRemark,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '新建时间',
            dataIndex: df.createTime,
            key: df.createTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'key',
            width: cellWidth.normal,
            key: 'action',
            align: 'center',
            fixed: 'right',
            render: (text, item) => this._renderActionCell(item.id, item)
        }
    ]);

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;
        const auditState = item[df.state], payStatus = item[df.payState];

        let items = [
            auditState === aud.AUDIT && <div className={styles.item} onClick={() => tableAction(key, tac.first, item)}>首次审核</div>,
            auditState === aud.FIRST_SUCCESS && <div className={styles.item} onClick={() => tableAction(key, tac.last, item)}>最终审核</div>,
            auditState === aud.FINAL_SUCCESS && payStatus !== ps.SUCCESS && payStatus !== ps.FAILED && payStatus !== ps.DOING && <div className={styles.item} onClick={() => tableAction(key, tac.pay, item)}>付款</div>
        ];

        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, ta.detail)}>详情</div>
                {/* {this.props.showAudit && items} */}
                {items}
            </div>
        );
    }

    // 表格复选输入
    _rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({ selectedRowKeys, selectedRows });
            this.props.tableAction([...selectedRowKeys], ta.batch);
        },
    };

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    // rowSelection={this._rowSelection}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    showAudit: PropTypes.bool,
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;